__turbopack_context__.v({
  "wrapper": "tabs-module-scss-module__YYe9Bq__wrapper",
});
